<template>
  <div>
    <!--General Top Bar -->
    <general-top-bar :title="$t('reports.fiscalZReport')"></general-top-bar>
    <!--End General Top Bar -->
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-12" style="width: 100%;">
          <div class="fiscal-z-filters">
            <div class="fiscal-z-filter" v-if="showLocations">
              <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
              <select class="form-control" v-model="orders.location">
                <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
                <template v-for="loc in locations">
                  <option :label="loc.name" :value="loc.id">{{loc.name}}</option>
                </template>
              </select>
            </div>
            <div class="fiscal-z-filter">
              <label class="form-label text-start w-100">{{$t('reports.zNumber')}}</label>
              <input
                type="number"
                min="0"
                name="z_number"
                :placeholder="$t('reports.zNumber')"
                v-model="orders.z_number"
                class="form-control">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
          <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
          </div>
        </p>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;"> {{ $t('reports.interval')}}: <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:00</b></p>
      </div>

      <!-- Totals Section -->
      <div class="col-md-12">
        <div class="row" style="display: flex; align-items: stretch; margin-bottom: 15px;">
          <div class="col-md-6" style="display: flex;">
            <div class="card center-sales-report-stats" style="width: 100%; min-height: 430px; display: flex; flex-direction: column;">
              <div class="card-content" v-loading="loading" style="flex: 1; display: flex; flex-direction: column;">
                <div class="report-container" style="flex: 1; overflow-y: auto;">
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalSales')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_sales || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.cash')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.cash || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.cardPayment')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.card || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.credit')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.credit || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.mealTickets')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.meal_tickets || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.valueTickets')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.value_tickets || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.voucher')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.voucher || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.modernPayment')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.modern_payment || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.advanceInCash')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.advance_in_cash || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.otherMethods')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.other_methods || 0)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" style="display: flex;">
            <div class="card center-sales-report-stats" style="width: 100%; min-height: 430px; display: flex; flex-direction: column;">
              <div class="card-content" v-loading="loading" style="flex: 1; display: flex; flex-direction: column;">
                <div class="report-container" style="flex: 1; overflow-y: auto;">
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalVat')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_vat || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalVatA')}} (21%)</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_vat_a || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalVatB')}} (11%)</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_vat_b || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalVatC')}} (0%)</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_vat_c || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalVatD')}} (0%)</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_vat_d || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalVatE')}} (0%)</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_vat_e || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalSalesA')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_sales_a || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalSalesB')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_sales_b || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalSalesC')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_sales_c || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalSalesD')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_sales_d || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.totalSalesE')}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(productsTableDataTotals.total_sales_e || 0)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.nrFiscalReceipts')}}</div>
                    <div class="report-col right-align">{{productsTableDataTotals.nr_fiscal_receipts || 0}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.nrNonFiscalReceipts')}}</div>
                    <div class="report-col right-align">{{productsTableDataTotals.nr_non_fiscal_receipts || 0}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns" style="width: 100%;">
          <data-tables-server
            @query-change="paginationChanged"
            v-loading="loading"
            :data="productsTableData"
            :total="totalOrders"
            :pagination-props="paginationProps"
            ref="reportsTable"
          >
            <el-table-column class-name="centered-cell" min-width="60" label="">
              <template slot-scope="props">
                <i class="ti-eye" style="cursor: pointer; font-size: 18px; color: #3B4BFF;" @click="openRawDataModal(props.row)"></i>
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" prop="z_number" :label="$t('reports.zNumber')" min-width="100"/>
            <el-table-column class-name="centered-cell" prop="device_name" :label="$t('reports.deviceName')" min-width="120"/>
            <el-table-column class-name="centered-cell" prop="z_timestamp" :label="$t('reports.zTimestamp')" min-width="160">
              <template slot-scope="props">
                {{ props.row.z_timestamp ? formatToCompanyTimezone(props.row.z_timestamp) : '-' }}
              </template>
            </el-table-column>

            <el-table-column class-name="centered-cell" prop="cash_in_drawer" :label="$t('reports.cashInDrawer')" min-width="140">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.cash_in_drawer || 0)) }}
              </template>
            </el-table-column>
            
            <!-- Payment Methods (raw order) -->
            <el-table-column
              prop="cash"
              min-width="120"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.cash'), productsTableDataTotals.cash)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.cash || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="card"
              min-width="120"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.cardPayment'), productsTableDataTotals.card)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.card || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="credit"
              min-width="120"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.credit'), productsTableDataTotals.credit)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.credit || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="meal_tickets"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.mealTickets'), productsTableDataTotals.meal_tickets)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.meal_tickets || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="value_tickets"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.valueTickets'), productsTableDataTotals.value_tickets)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.value_tickets || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="voucher"
              min-width="120"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.voucher'), productsTableDataTotals.voucher)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.voucher || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="modern_payment"
              min-width="150"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.modernPayment'), productsTableDataTotals.modern_payment)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.modern_payment || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="advance_in_cash"
              min-width="150"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.advanceInCash'), productsTableDataTotals.advance_in_cash)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.advance_in_cash || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="other_methods"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.otherMethods'), productsTableDataTotals.other_methods)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.other_methods || 0)) }}
              </template>
            </el-table-column>

            <!-- Sales A-E, other taxes, VAT exempt, then total sales -->
            <el-table-column
              prop="total_sales_a"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalSalesA'), productsTableDataTotals.total_sales_a)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales_a || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_sales_b"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalSalesB'), productsTableDataTotals.total_sales_b)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales_b || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_sales_c"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalSalesC'), productsTableDataTotals.total_sales_c)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales_c || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_sales_d"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalSalesD'), productsTableDataTotals.total_sales_d)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales_d || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_sales_e"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalSalesE'), productsTableDataTotals.total_sales_e)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales_e || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_other_taxes"
              min-width="150"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalOtherTaxes'), productsTableDataTotals.total_other_taxes)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_other_taxes || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_vat_exempt"
              min-width="150"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVatExempt'), productsTableDataTotals.total_vat_exempt)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat_exempt || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_sales"
              min-width="140"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalSales'), productsTableDataTotals.total_sales)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_sales || 0)) }}
              </template>
            </el-table-column>
            
            <!-- VAT A-E then total (raw order) -->
            <el-table-column
              prop="total_vat_a"
              min-width="130"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVatA'), productsTableDataTotals.total_vat_a)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat_a || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="total_vat_b"
              min-width="130"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVatB'), productsTableDataTotals.total_vat_b)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat_b || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="total_vat_c"
              min-width="130"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVatC'), productsTableDataTotals.total_vat_c)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat_c || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="total_vat_d"
              min-width="130"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVatD'), productsTableDataTotals.total_vat_d)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat_d || 0)) }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="total_vat_e"
              min-width="130"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVatE'), productsTableDataTotals.total_vat_e)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat_e || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="total_vat"
              min-width="120"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.totalVat'), productsTableDataTotals.total_vat)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total_vat || 0)) }}
              </template>
            </el-table-column>

            <!-- Fiscal code clients (raw order: VAT, sum, nr) -->
            <el-table-column
              prop="fiscal_code_clients_total_vat"
              min-width="200"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.fiscalCodeClientsTotalVat'), productsTableDataTotals.fiscal_code_clients_total_vat)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.fiscal_code_clients_total_vat || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="fiscal_code_clients_total_sum"
              min-width="200"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.fiscalCodeClientsTotalSum'), productsTableDataTotals.fiscal_code_clients_total_sum)"
            >
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.fiscal_code_clients_total_sum || 0)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="nr_fiscal_code_client_receipts"
              min-width="200"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.nrFiscalCodeClientReceipts'), productsTableDataTotals.nr_fiscal_code_client_receipts)"
            >
              <template slot-scope="props">
                {{ props.row.nr_fiscal_code_client_receipts || 0 }}
              </template>
            </el-table-column>
            
            <!-- Receipts Count -->
            <el-table-column
              prop="nr_fiscal_receipts"
              min-width="150"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.nrFiscalReceipts'), productsTableDataTotals.nr_fiscal_receipts)"
            >
              <template slot-scope="props">
                {{ props.row.nr_fiscal_receipts || 0 }}
              </template>
            </el-table-column>
            
            <el-table-column
              prop="nr_non_fiscal_receipts"
              min-width="180"
              class-name="centered-cell"
              :render-header="h => renderHeaderWithTotal(h, $t('reports.nrNonFiscalReceipts'), productsTableDataTotals.nr_non_fiscal_receipts)"
            >
              <template slot-scope="props">
                {{ props.row.nr_non_fiscal_receipts || 0 }}
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>

    <!-- Raw Data Modal — Fiscal Z document preview -->
    <vmodal name="rawDataModal" height="auto" width="620" :adaptive="true" :scrollable="true">
      <div class="z-receipt-doc">
        <div class="z-receipt-doc__header">
          <div class="z-receipt-doc__heading">
            <h4 class="z-receipt-doc__title">
              {{ $t('reports.fiscalZReport') }} · Z {{ selectedRawDataRow.z_number || '-' }}
            </h4>
            <p class="z-receipt-doc__subtitle">
              <span v-if="selectedRawDataRow.device_name">{{ selectedRawDataRow.device_name }}</span>
              <span
                v-if="selectedRawDataRow.device_name && selectedRawDataRow.z_timestamp"
                class="z-receipt-doc__dot"
              >•</span>
              <span v-if="selectedRawDataRow.z_timestamp">
                {{ formatToCompanyTimezone(selectedRawDataRow.z_timestamp) }}
              </span>
            </p>
          </div>
          <el-button
            type="text"
            class="z-receipt-doc__close"
            :title="$t('general.close')"
            @click="closeRawDataModal"
          >
            <i class="el-icon-close"></i>
          </el-button>
        </div>

        <div class="z-receipt-doc__body">
          <!-- Hero total -->
          <div
            v-if="rawSummarySections.length && selectedRawDataRow.total_sales !== undefined"
            class="z-receipt-hero"
          >
            <span class="z-receipt-hero__label">{{ $t('reports.totalSales') }}</span>
            <span class="z-receipt-hero__value">
              {{ formatMoneyAmount(Number(selectedRawDataRow.total_sales || 0)) }}
            </span>
          </div>

          <!-- Structured summary cards -->
          <div
            v-for="section in rawSummarySections"
            :key="section.id"
            class="z-receipt-card"
          >
            <div class="z-receipt-card__title">{{ section.title }}</div>
            <div class="z-receipt-card__rows">
              <div
                v-for="item in section.rows"
                :key="item.key"
                class="z-receipt-line"
              >
                <span class="z-receipt-line__label">{{ item.label }}</span>
                <span class="z-receipt-line__value">{{ item.value }}</span>
              </div>
            </div>
          </div>

          <!-- Raw fiscal output (secondary) -->
          <div v-if="rawOutputText" class="z-receipt-raw">
            <button
              type="button"
              class="z-receipt-raw__toggle"
              @click="rawExpanded = !rawExpanded"
            >
              <span>Raport fiscal brut</span>
              <i :class="rawExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </button>
            <pre v-show="rawExpanded" class="z-receipt-raw__panel">{{ rawOutputText }}</pre>
          </div>

          <!-- Empty state -->
          <div
            v-if="!rawSummarySections.length && !rawOutputText"
            class="z-receipt-empty"
          >
            {{ $t('reports.noRawData') }}
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
import Vue from 'vue'
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  components: {
    // GeneralTopBar,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isMasterReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isMasterReport () {
      if (this.isMasterReport) {
        this.getTopCategories()
        this.getPaymentMethods()
        this.getSections()
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
        this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
        this.getPosUsers()
      }
    }
  },
  // created () {
  //   this.getTopCategories()
  //   this.getPaymentMethods()
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  //   this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
  //   this.getPosUsers()
  // },
  data () {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      productsTableData: [],
      posUsers: [],
      selectedPosUser: null,
      timezone: null,
      productsTableDataTotals: {},
      paymentMethods: [],
      orderId: null,
      receiptOptions: [
        { label: this.$t('reports.withoutReceipt'), value: 1 },
        { label: this.$t('reports.withReceipt'), value: 2 }
      ],
      selectedDriver: '',
      selected_user: '',
      selected_order_from: '',
      selected_payment_methods: [],
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: '',
        z_number: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      ordersTableData: {},
      totalOrders: null,
      // use_tips: this.$session.get('tips_use')
      topCategories: [],
      topCategoryId: [],
      sections: [],
      sectionId: [],
      hasRceipt: null,
      noData: false,
      totalSum: 0,
      selectedRawDataRow: {},
      rawExpanded: false
    }
  },
  computed: {
    // Builds structured summary cards from the row's own fields (money / counts).
    rawSummarySections () {
      const row = this.selectedRawDataRow || {}
      const has = (k) => row[k] !== undefined && row[k] !== null && row[k] !== ''
      const money = (k) => this.formatMoneyAmount(Number(row[k] || 0))
      const count = (k) => String(row[k] != null ? row[k] : 0)

      const defs = [
        {
          id: 'payments',
          title: this.$t('reports.paymentMethod'),
          fields: [
            { key: 'cash_in_drawer', label: this.$t('reports.cashInDrawer'), fmt: money },
            { key: 'cash', label: this.$t('reports.cash'), fmt: money },
            { key: 'card', label: this.$t('reports.cardPayment'), fmt: money },
            { key: 'credit', label: this.$t('reports.credit'), fmt: money },
            { key: 'meal_tickets', label: this.$t('reports.mealTickets'), fmt: money },
            { key: 'value_tickets', label: this.$t('reports.valueTickets'), fmt: money },
            { key: 'voucher', label: this.$t('reports.voucher'), fmt: money },
            { key: 'modern_payment', label: this.$t('reports.modernPayment'), fmt: money },
            { key: 'advance_in_cash', label: this.$t('reports.advanceInCash'), fmt: money },
            { key: 'other_methods', label: this.$t('reports.otherMethods'), fmt: money }
          ]
        },
        {
          id: 'sales',
          title: this.$t('reports.totalSales'),
          fields: [
            { key: 'total_sales_a', label: this.$t('reports.totalSalesA'), fmt: money },
            { key: 'total_sales_b', label: this.$t('reports.totalSalesB'), fmt: money },
            { key: 'total_sales_c', label: this.$t('reports.totalSalesC'), fmt: money },
            { key: 'total_sales_d', label: this.$t('reports.totalSalesD'), fmt: money },
            { key: 'total_sales_e', label: this.$t('reports.totalSalesE'), fmt: money },
            { key: 'total_other_taxes', label: this.$t('reports.totalOtherTaxes'), fmt: money },
            { key: 'total_vat_exempt', label: this.$t('reports.totalVatExempt'), fmt: money },
            { key: 'total_sales', label: this.$t('reports.totalSales'), fmt: money }
          ]
        },
        {
          id: 'vat',
          title: this.$t('reports.totalVat'),
          fields: [
            { key: 'total_vat_a', label: this.$t('reports.totalVatA'), fmt: money },
            { key: 'total_vat_b', label: this.$t('reports.totalVatB'), fmt: money },
            { key: 'total_vat_c', label: this.$t('reports.totalVatC'), fmt: money },
            { key: 'total_vat_d', label: this.$t('reports.totalVatD'), fmt: money },
            { key: 'total_vat_e', label: this.$t('reports.totalVatE'), fmt: money },
            { key: 'total_vat', label: this.$t('reports.totalVat'), fmt: money }
          ]
        },
        {
          id: 'fiscal',
          title: this.$t('reports.fiscalization'),
          fields: [
            { key: 'fiscal_code_clients_total_vat', label: this.$t('reports.fiscalCodeClientsTotalVat'), fmt: money },
            { key: 'fiscal_code_clients_total_sum', label: this.$t('reports.fiscalCodeClientsTotalSum'), fmt: money },
            { key: 'nr_fiscal_code_client_receipts', label: this.$t('reports.nrFiscalCodeClientReceipts'), fmt: count },
            { key: 'nr_fiscal_receipts', label: this.$t('reports.nrFiscalReceipts'), fmt: count },
            { key: 'nr_non_fiscal_receipts', label: this.$t('reports.nrNonFiscalReceipts'), fmt: count }
          ]
        }
      ]

      const sections = []
      defs.forEach((def) => {
        const rows = def.fields
          .filter((f) => has(f.key))
          .map((f) => ({ key: f.key, label: f.label, value: f.fmt(f.key) }))
        if (rows.length) {
          sections.push({ id: def.id, title: def.title, rows: rows })
        }
      })
      return sections
    },
    // Raw fiscal printer text (string) or a pretty-printed object dump.
    rawOutputText () {
      const raw = this.selectedRawDataRow && this.selectedRawDataRow.raw_data
      if (raw == null || raw === '') return ''
      if (typeof raw === 'string') return raw
      try {
        return JSON.stringify(raw, null, 2)
      } catch (e) {
        return String(raw)
      }
    }
  },
  methods: {
    formatToCompanyTimezone (utcString) {
      const date = new Date(utcString + 'Z')
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: this.timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })

      const parts = formatter.formatToParts(date)

      return `${parts.find(p => p.type === 'year').value}-${
        parts.find(p => p.type === 'month').value}-${
        parts.find(p => p.type === 'day').value} ${
        parts.find(p => p.type === 'hour').value}:${
        parts.find(p => p.type === 'minute').value}:${
        parts.find(p => p.type === 'second').value}`
    },
    getPaymentMethods () {
      let sessionData = this.$session.get('selectedCompanyData')

      if (!sessionData['payment_methods']) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
          if (response.status && response.data.length) {
            let result = response.data.map(item => {
              return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
            })
            sessionData['payment_methods'] = response.data
            this.$session.set('selectedCompanyData', sessionData)

            Vue.set(this, 'paymentMethods', result)
          }
        })
      } else {
        let result = sessionData['payment_methods'].map(item => {
          return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
        })
        Vue.set(this, 'paymentMethods', result)
      }
    },
    getTopCategories () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/topcategory', 'GET', data, (response) => {
        if (response.status === true) {
          this.topCategories = response.data
        }
      })
    },
    getSections () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/sections', 'GET', data, (response) => {
        if (response.status === true) {
          this.sections = response.data
        }
      })
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    },
    changeValidFrom () {
      // if (this.valid_to <= this.valid_from) {
      //   this.valid_to = '23:59'
      // }
      if (!this.valid_from) {
        this.valid_from = '05:00'
      }
      if (!this.valid_to) {
        this.valid_to = '05:00'
      }
    },
    paginationChanged (query) {
      // Avoid concurrent requests while a load is in progress
      if (this.loading) {
        return
      }
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    renderHeaderWithTotal (h, label, total) {
      return h('div', {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: '100%',
          textAlign: 'center',
          padding: '4px',
          boxSizing: 'border-box',
          justifyContent: 'space-between',
          overflow: 'visible'
        }
      }, [
        h('div', {
          style: {
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            hyphens: 'auto',
            whiteSpace: 'normal',
            lineHeight: '1.2',
            minWidth: '0'
          }
        }, label),
        h('div', {
          style: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: '4px'
          }
        }, [
          h('span', {
            style: {
              background: '#674BD2',
              color: '#fff',
              borderRadius: '5px',
              padding: '2px 6px',
              fontWeight: 'bold',
              fontSize: '12px',
              lineHeight: '1',
              whiteSpace: 'nowrap',
              display: 'inline-block'
            }
          }, total)
        ])
      ])
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    isUnpaidSelected () {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return false
      }
      // Handle both string IDs and objects
      return this.selected_payment_methods.some(method => {
        const id = typeof method === 'string' ? method : (method && method.id)
        return id === 'unpaid'
      })
    },
    getPaymentMethodsArray () {
      if (!this.selected_payment_methods || !Array.isArray(this.selected_payment_methods)) {
        return []
      }
      // Extract IDs from array, filter out 'unpaid', and ensure we only have strings
      return this.selected_payment_methods
        .map(method => {
          // If it's already a string, use it; otherwise extract the id
          return typeof method === 'string' ? method : (method && method.id ? method.id : null)
        })
        .filter(method => method && method !== 'unpaid') // Remove null/undefined and 'unpaid'
    },
    getOrders (query) {
      if (!this.isMasterReport) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        operator: this.selectedPosUser
      }

      if (this.topCategoryId) {
        const result = this.topCategoryId.map(elem => {
          return elem.id
        })
        data.top_category_id = result
      }

      if (this.sectionId) {
        const result = this.sectionId.map(elem => {
          return elem.id
        })
        data.section_id = result
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.orders.z_number !== '' && this.orders.z_number !== null && this.orders.z_number !== undefined) {
        data.z_number = this.orders.z_number
      }

      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1
      const hasReceiptValue = (this.hasRceipt && this.hasRceipt.value) || null

      this.apiRequest('/reports/v2/fiscal-z-reports' + '?page=' + page + '&perPage=' + pageSize + '&has_receipt=' + hasReceiptValue, 'GET', data, response => {
        if (response.status) {
          this.productsTableData = response.data.table_data || []
          this.totalOrders = response.pagination.total
          this.paginationProps.currentPage = response.pagination.page
          this.paginationProps.pageSize = response.pagination.perPage
          this.productsTableDataTotals = response.data.totals || {}
          this.totalSum = parseFloat(response.data.totals.total_sales || 0)
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      // Prevent triggering a new search while a request is in progress
      if (this.loading) {
        return
      }
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        order_id: this.orderId,
        selected_payment_methods: this.getPaymentMethodsArray(),
        unpaid_orders: this.isUnpaidSelected() ? 1 : 0,
        pageSize: this.paginationProps.pageSize,
        page: this.paginationProps.currentPage,
        has_receipt: (this.hasRceipt && this.hasRceipt.value) || null
      }

      if (this.topCategoryId) {
        const result = this.topCategoryId.map(elem => {
          return elem.id
        })
        data.top_category_id = result
      }

      if (this.sectionId) {
        const result = this.sectionId.map(elem => {
          return elem.id
        })
        data.section_id = result
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.orders.z_number !== '' && this.orders.z_number !== null && this.orders.z_number !== undefined) {
        data.z_number = this.orders.z_number
      }

      this.loading = true
      this.apiRequest('/reports/v2/fiscal-z-reports-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    },
    getPosUsers () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/pos/all/users', 'GET', data, (response) => {
        if (response.status) {
          this.posUsers = response.data.pos_user
        }
      })
    },
    openRawDataModal (row) {
      this.selectedRawDataRow = row || {}
      // Expand the raw panel automatically when there are no structured totals to show.
      const r = this.selectedRawDataRow
      const hasStructured = ['cash', 'card', 'total_sales', 'total_vat', 'nr_fiscal_receipts']
        .some((k) => r[k] !== undefined && r[k] !== null && r[k] !== '')
      this.rawExpanded = !hasStructured
      this.$modal.show('rawDataModal')
    },
    closeRawDataModal () {
      this.$modal.hide('rawDataModal')
      this.selectedRawDataRow = {}
    },
    formatRawDataLabel (key) {
      // Convert snake_case to camelCase for translation key
      const camelCaseKey = key.split('_').map((word, index) => {
        return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      }).join('')
      const translationKey = 'reports.rawData' + camelCaseKey.charAt(0).toUpperCase() + camelCaseKey.slice(1)
      const translated = this.$t(translationKey)
      // If translation exists and is different from the key, use it; otherwise format the key
      if (translated && translated !== translationKey) {
        return translated
      }
      return key.toUpperCase().replace(/_/g, ' ')
    },
    formatRawDataValue (key, value) {
      if (value === null || value === undefined) {
        return '0.00'
      }

      // Format monetary values
      if (typeof value === 'number') {
        if (key.includes('tva') || key.includes('vanz') || key.includes('val') ||
            key.includes('numerar') || key.includes('card') || key.includes('credit') ||
            key.includes('tichete') || key.includes('voucher') || key.includes('plata') ||
            key.includes('avans') || key.includes('metode') || key.includes('taxe') ||
            key.includes('sumar') || key.includes('capacitate') || key.includes('spatiu')) {
          return this.formatMoneyAmount(value.toFixed(2))
        }
        return value.toString()
      }

      // Format dates
      if (key === 'data' || key === 'nr_dmje_01') {
        return value
      }

      // Format percentages
      if (key.includes('spatiu_liber_dmje') && typeof value === 'string' && value.includes('%')) {
        return value
      }

      return String(value)
    }
  }
}
</script>
<style>
  .fiscal-z-filters {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
    gap: 12px;
    width: 100%;
  }
  .fiscal-z-filter {
    flex: 1 1 0;
    min-width: 0;
    margin: 0;
  }
  .fiscal-z-filter .form-label {
    margin-bottom: 6px;
  }
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .centered-cell .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-table th .cell {
    white-space: normal;
    line-height: 1.4;
  }

  .centered-cell .cell {
    text-align: center !important;
    white-space: normal;
  }

  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 15px !important;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 100% !important;
    height: 100% !important;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
    font-size: 15px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-weight: 500;
  }
  .left-align {
    text-align: left;
  }
  .right-align {
    text-align: right;
  }
  /* Fiscal Z document preview modal */
  .z-receipt-doc {
    --z-accent: #25396F;
    --z-ink: #1f2733;
    --z-muted: #7a869a;
    --z-line: #eceff4;
    --z-surface: #ffffff;
    --z-panel: #f6f8fc;
    background: var(--z-surface);
    border-radius: 10px;
    overflow: hidden;
    color: var(--z-ink);
    font-family: inherit;
  }
  .z-receipt-doc__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    background: linear-gradient(180deg, #f7f9fd 0%, #ffffff 100%);
    border-bottom: 1px solid var(--z-line);
  }
  .z-receipt-doc__heading {
    min-width: 0;
  }
  .z-receipt-doc__title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--z-accent);
    line-height: 1.25;
    word-break: break-word;
  }
  .z-receipt-doc__subtitle {
    margin: 6px 0 0;
    font-size: 13px;
    color: var(--z-muted);
    line-height: 1.4;
    word-break: break-word;
  }
  .z-receipt-doc__dot {
    margin: 0 7px;
    color: #c3ccdb;
  }
  .z-receipt-doc__close {
    flex: 0 0 auto;
    padding: 0;
    margin: -2px -4px 0 0;
    font-size: 20px;
    line-height: 1;
    color: var(--z-muted);
  }
  .z-receipt-doc__close:hover,
  .z-receipt-doc__close:focus {
    color: var(--z-accent);
  }
  .z-receipt-doc__body {
    max-height: 70vh;
    overflow-y: auto;
    padding: 18px 20px 22px;
    background: var(--z-panel);
  }
  .z-receipt-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px;
    margin-bottom: 14px;
    border-radius: 10px;
    background: var(--z-accent);
    color: #fff;
    box-shadow: 0 6px 18px rgba(37, 57, 111, 0.22);
  }
  .z-receipt-hero__label {
    font-size: 12px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    opacity: 0.85;
  }
  .z-receipt-hero__value {
    font-size: 22px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
  .z-receipt-card {
    background: var(--z-surface);
    border: 1px solid var(--z-line);
    border-radius: 10px;
    padding: 4px 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(31, 39, 51, 0.04);
  }
  .z-receipt-card__title {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--z-accent);
    padding: 12px 0 4px;
  }
  .z-receipt-line {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 0;
    border-top: 1px solid var(--z-line);
    font-size: 14px;
  }
  .z-receipt-card__title + .z-receipt-card__rows .z-receipt-line:first-child {
    border-top: none;
  }
  .z-receipt-line__label {
    color: #55617a;
    word-break: break-word;
  }
  .z-receipt-line__value {
    flex: 0 0 auto;
    font-weight: 600;
    color: var(--z-ink);
    font-variant-numeric: tabular-nums;
    text-align: right;
    white-space: nowrap;
  }
  .z-receipt-raw {
    margin-top: 4px;
  }
  .z-receipt-raw__toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 16px;
    border: 1px solid var(--z-line);
    border-radius: 10px;
    background: var(--z-surface);
    color: var(--z-accent);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease;
  }
  .z-receipt-raw__toggle:hover {
    background: #f2f5fb;
  }
  .z-receipt-raw__panel {
    margin: 8px 0 0;
    padding: 16px;
    background: #1e2530;
    color: #dfe6f1;
    border-radius: 10px;
    font-family: 'SFMono-Regular', 'Menlo', 'Consolas', 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 320px;
    overflow: auto;
  }
  .z-receipt-empty {
    text-align: center;
    padding: 40px 12px;
    color: var(--z-muted);
    font-size: 14px;
  }
  @media (max-width: 560px) {
    .z-receipt-doc__header {
      padding: 14px 14px;
    }
    .z-receipt-doc__body {
      padding: 14px 14px 18px;
      max-height: 72vh;
    }
    .z-receipt-hero {
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/FiscalZReport.vue